import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import serverVars from 'server-vars';
import { actionCreators } from '../actions';

const getBuyerFooterClient = ({ node, store, relayEnv }) => {
    const isMobile = serverVars.get('settings.isMobile');

    let navPromise;
    if (!isMobile) {
        navPromise = import(
            /* webpackChunkName: "responsiveFooter" */ '../components/responsiveFooter'
        );
    } else {
        navPromise = import(/* webpackChunkName: "mobileFooter" */ '../components/mobileFooter');
    }

    navPromise.then(({ FooterRenderer, footerInitialVariables, footerRootQuery }) => {
        const localeDataKey = serverVars.get('localeDataKey');
        const messages = serverVars.get('messages');

        hydrate(
            <IntlProvider locale={localeDataKey} messages={messages}>
                <Provider store={store}>
                    <FooterRenderer
                        environment={relayEnv}
                        initialVariables={footerInitialVariables}
                        query={footerRootQuery}
                    />
                </Provider>
            </IntlProvider>,
            node
        );

        return {
            updateUserState: store.dispatch.bind(null, actionCreators.setUpdateUserState(true)),
        };
    });
};

export { getBuyerFooterClient };
